import { Action, any, async, fromJSX, nothing } from "widgets-for-react"
import { EventDetailsFrontend } from "../../../backendApi/generated"
import { hasValue } from "../../../utils/asyncState"
import { scrollToTop } from "../../../utils/browser"
import { isSome, valueOrExcept } from "../../../utils/option"
import { emptyJumbo } from "../../Jumbo/Jumbo"
import { EventDetailsLayout } from "./EventDetailsLayout"
import { EventDetailsState } from "./EventDetailsState"
import { EventsOverviewClassNames } from "../EventOverview/EventOverviewState"
import { features } from "../../../features"

export const EventDetailsWidget = (props: EventDetailsState & { eventsOverviewClassNames: EventsOverviewClassNames }) =>
  any<Action<EventDetailsState>>({ key: 'EventDetails' })(
    [
      // Render Layout
      fromJSX(() => {
        if (props.event.kind == 'failed') return features().error
        if (!hasValue(props.event)) return props.Jumbo({ ...emptyJumbo })

        const event = props.event.value
        const cmsContent = event.CMSContent

        if (cmsContent?.Kind == 'fullReplacement') {
          const customCmsPage = props.renderCustomCmsPage(cmsContent.JsonBlob)
          if (isSome(customCmsPage)) return valueOrExcept(customCmsPage)
        }

        let pageTitle = event.Title
        let notice = undefined

        return EventDetailsLayout({ ...props, notice, pageTitle, event })
      }),

      // Manage async state updates
      async<EventDetailsFrontend>(nothing, { key: 'eventLoader' })(props.event)
        .map(resultUpdater => s0 => {
          const event = resultUpdater(s0.event)
          if (s0.event.kind != 'loaded' && event.kind == 'loaded') scrollToTop()
          return ({ ...s0, event })
        })
    ]
  ).map(a => a(props))
